module.exports = __webpack_public_path__ + "static/img/11.8988f1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/11.jpg
// module id = z9A3
// module chunks = 1